import React, { useState, useEffect } from 'react';
import styles from '../static/styles/Notifications.module.css';
import ArrowLeft from '../static/img/backArrow.png'
import firstNotificationBG from '../static/img/DailyTasks/iconCompletedBG.svg';
import { getUserNotifCount, getUserNotifs } from '../api/profile';
import { trackSectionView } from '../utils/analytics';
import { useNavigate } from 'react-router-dom';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    trackSectionView('notifications');
    document.title = 'Notifications | Jazz Esl';

    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const result = await getUserNotifs();

        if (result.success && result.EntryNotifications) {
          const formattedNotifications = result.EntryNotifications.map((notif, index) => ({
            id: index + 1,
            title: 'Notification',
            message: notif.message,
            isRead: notif.seen === 1,
          }));
          setNotifications(formattedNotifications);

          window.dispatchEvent(new Event('notificationsRead'));
        } else {
          setNotifications([]);
        }
      } catch (error) {
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  const unreadCount = notifications.filter(n => !n.isRead).length;

  const gradients = [
    "linear-gradient(135deg, #1A0A3D, #080014)",
    "linear-gradient(135deg, #3D0A14, #1A0005)",
    "linear-gradient(135deg, #1A3D0A, #0A1A00)",
    "linear-gradient(135deg, #280A3D, #0C001A)",
  ];


  return (
    <div className={styles.container}>
      <div className={styles.navigationHeader}>
        <div
          className={styles.navigationBack}
          onClick={() => navigate(-1)}
        >
          <img src={ArrowLeft} alt="<" />
        </div>
        <div className={styles.navigationTitle}>
          <p>esl</p>
          <h2 className={styles.heading}>notifications</h2>
        </div>
      </div>
      <div className={styles.gamingTaskHeader}>
        <p className={styles.subheading}>Stay updated</p>
        <h2 className={styles.heading}>ESL NOTIFICATIONS</h2>
        <div className={styles.headerstatsContainer}>
          <div className={styles.headerstats}>
            <span>{notifications.length}</span>
            <p>new</p>
          </div>
          <div className={styles.headerstats}>
            <span>{unreadCount}</span>
            <p>unread</p>
          </div>
        </div>
      </div>

      {loading && <div className={styles.loading}>Loading notifications...</div>}

      <div className={styles.notificationsContainer}>
        {notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <div
              key={notification.id}
              className={styles.notificationCard}
              style={{
                "--bg": gradients[index % gradients.length],
              }}>
            
              <div className={styles.notificationContent}>
                <div className={styles.notificationText}>
                  <p className={styles.notificationTitle}>{notification.title}</p>
                  <p className={styles.notificationMessage}>{notification.message}</p>
                </div>
              </div>
            </div>
          ))
        ) : !loading && (
          <div className={styles.noNotifications}>No notifications available</div>
        )}
      </div>
    </div>
  );
};

export default Notifications;
